import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

const searchPageRoutes = [
  '/:regionCode/search',
  '/:regionCode/flights-search-results',
]

/**
 * Tells us whether we are currently on an search page or not
 */
function useIsSearchPage() {
  const location = useLocation()
  return useMemo(() => {
    return !!matchLocaleAwarePath(location.pathname, { path: searchPageRoutes })
  }, [location.pathname])
}

export default useIsSearchPage
